<template>
    <div style="display: flex; flex-direction: column;">
        <div>
            <MercenaryHeader :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
            <div style="text-align: center; padding: 0 12px;">
                <div style="font-size: 24px; font-weight: 700; margin-bottom: 12px;">사커하우 실시간 소식</div>
                <div style="color: #808080; font-size: 12px; font-weight: 700; gap: 12px; display: flex; align-items: center; justify-content: center;">{{ today }}<span>|</span>5분 전 업데이트</div>
                <div style="font-weight: 500; font-size: 14px; line-height: 24px; margin-top: 6px;">유소년 선수 유저의 실시간 입단 소식이 업데이트 됩니다.</div>
            </div>
        </div>
        <InfinityScroll style="margin-top: 12px; flex: 1; overflow:auto;" :is-enable-next-page-handle="isEnableNextPageHandle" :handle-next-page="handleNextPage">
            <div style="padding: 16px 12px;">
                <div v-for="each, i in newsList" :key="i" style="display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 32px;">
                    <div>
                        <div style="color: #606060; font-weight: 700; font-size: 14px; line-height: 20px; margin-bottom: 4px;">{{ each.from_member.team ? each.from_member.team.name : '' }}</div>
                        <div style="line-height: 20px; font-size: 14px; font-weight: 500;">
                            <span>{{ each.from_member.nic_name }}</span> 감독,
                            <span style="font-weight: 700;">
                                <span v-if="!each.refer_idx">{{ each.to_member.nic_name }}</span>
                                <span v-else>{{ each.to_member.nic_name.slice(0, 1) }}**</span>
                                <span v-if="!each.refer_idx" style="font-weight: 700; color: var(--color-main);">
                                    <DivisionPositionText :position="each.to_member.position" :positionProAbility="each.to_member.position_pro_ability"></DivisionPositionText>
                                </span>
                            </span>
                            <span v-if="each.news_type == REAL_TIME_NEWS_TYPE.SCOUT">를 스카웃했습니다. 👏</span>
                            <span v-else>에게 관심을 갖고 있습니다.🤔</span>
                        </div>
                        <div style="margin-top: 8px; font-size: 12px; font-weight: 500; line-height: 20px; color: #606060;">{{ each.insert_date | agoDateStr }}</div>
                    </div>
                    <div style="height: 60px; width: 60px; flex-shrink: 0; border-radius: 12px; overflow: hidden;" v-if="each.from_member.team && each.from_member.team.image_path">
                        <img 
                            style="width: 100%; height: 100%;" 
                            :src="each.from_member.team ? $resourcePath + each.from_member.team.image_path : ''"
                            alt=""
                        >
                    </div>
                </div>
            </div>
        </InfinityScroll>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import { REAL_TIME_NEWS_TYPE } from '@/Constants'
import moment from 'moment'
import InfinityScroll from "../common/InfinityScroll";
import DivisionPositionText from "@/components/common/DivisionPositionText"

export default {
    name: "SoccerhowRealTimeNews",
    components: {InfinityScroll, MercenaryHeader, DivisionPositionText },
    data() {
        return {
            newsList: [],
            REAL_TIME_NEWS_TYPE: REAL_TIME_NEWS_TYPE,
            today: '',
            isEnableNextPageHandle : true,
            real_time_news: [],
            page : 1,
        }
    },
    methods: {
        async getRealTimeNewsList() {
            this.isEnableNextPageHandle = false;
            const parameters = {}
            parameters.page = this.page;
            const res = await this.$Axios.get('/api/real_time/list', { params: parameters })

            const real_time_news = res.data.real_time_news;
            this.real_time_news = real_time_news
            this.exceptionManager()

            if(this.real_time_news.length > 0){
                this.isEnableNextPageHandle = true;
                this.newsList = [...this.newsList, ...this.real_time_news];
                this.exceptionManager()
            }
        },
        exceptionManager() {
            if (process.env.NODE_ENV === 'production') {
                this.real_time_news = this.real_time_news.filter(item => 
                    item.from_member_idx != 462310 && item.to_member_idx != 462310
                );
            }
        },
        handleNextPage(){
            this.page++;
            this.getRealTimeNewsList();
        }
    },
    created() {
        this.getRealTimeNewsList()
        const today = moment().format('YYYY년 MM월 DD일')
        this.today = today
    }
}
</script>

<style scoped></style>